<template>
  <div class="expert-info wrap-content">
    <div class="wrap-inner">
      <div class="wrap-form">
        <Alert>收集个人信息仅为支付评阅费用、报税使用，不会将信息泄露给第三方，请您务必填写并核实无误！</Alert>
        <Form :model="userMsg" :label-width="120" ref="thesisEditForm" inline :rules="validateRules">
          <FormItem  readonly="readonly" label="姓名：" prop="name">
            <Input v-model="userMsg.name" placeholder="请输入姓名"></Input>
          </FormItem>
          <FormItem label="证件类型：" prop="idCardType">
            <Select v-model="userMsg.idCardType"
                    filterable
            >
              <Option v-for="(option, index) in allCardTypeList" :value="option.value" :key="index">{{option.label}}</Option>
            </Select>
          </FormItem>
          <FormItem label="证件号：" prop="identityCard">
            <Input v-model="userMsg.identityCard" placeholder="请输入证件号"></Input>
          </FormItem>
          <FormItem  readonly="readonly" label="手机号：" prop="mobile">
            <Input v-model="userMsg.mobile" placeholder="请输入手机号"></Input>
          </FormItem>
          <FormItem label="电子邮箱：" prop="email">
            <Input type="email" v-model="userMsg.email" placeholder="请输入电子邮件"></Input>
          </FormItem>
          <!-- bank -->
          <FormItem label="开户省份：" prop="bankProvince">
            <Select v-model="userMsg.bankProvince">
              <Option v-for="(option, index) in proList" :value="option.id" :key="index">{{option.mc}}</Option>
            </Select>
          </FormItem>
          <FormItem label="开户银行：" prop="bankId">
            <Select v-model="userMsg.bankId">
              <Option v-for="(option, index) in bankList" :value="option.id" :key="index">{{option.mc}}</Option>
            </Select>
          </FormItem>
          <FormItem label="开户行支行：" prop="branch">
            <Input v-model="userMsg.branch" placeholder="请输入开户行支行"></Input>
          </FormItem>
          <FormItem label="银行卡号：" prop="bankCard">
            <Input v-model="userMsg.bankCard" placeholder="请输入银行卡号"></Input>
          </FormItem>
        </Form>
        <div style="width:100%;display:flex;justify-content: center;align-items: center;margin-top:20px">
          <Button type="primary" @click="saveOrUpdate">保  存</Button>
        </div>
      </div>
      <Spin size="large" fix v-if="loading"></Spin>
    </div>
  </div>
</template>

<script>
/* global FormItemRules:true */
export default {
  props: {
    query: ''
  },
  data () {
    // 身份证号验证规则
    const isSFZH = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('证件号码不能为空'));
      }
      return callback();
    };
    const isEMAIL = (rule, value, callback) => {
      if (value) {
        if (!this.formDefaultRules.isEMAIL.test(value)) {
          return callback(new Error('输入的电子邮箱不符合规则'));
        }
      }
      return callback();
    };
    const isPHONE = (rule, value, callback) => {
      if (value) {
        if (!this.formDefaultRules.isPHONE.test(value)) {
          return callback(new Error('输入的手机号不符合规则'));
        }
      }
      return callback();
    };
    const isRoleEmpty = (rule, value, callback) => {
      if (value.length === 0) {
        return callback(new Error('角色不能为空'));
      }
      return callback();
    };
    return {
      validateRules: {
        username: [{required: true, message: '用户名不能为空', trigger: 'blur'}],
        name: [{required: true, message: '姓名不能为空', trigger: 'blur'}],
        branch: [{required: true, message: '开户行支行不能为空', trigger: 'blur'}],
        idCardType: [{required: true, message: '证件类型不能为空', trigger: 'blur'}],
        identityCard: [{required: true, message: '证件号码不能为空', trigger: 'blur'}, {validator: isSFZH, trigger: 'blur'}],
        mobile: [{required: true, message: '手机号不能为空', trigger: 'blur'}, {validator: isPHONE, trigger: 'blur'}],
        email: [{validator: isEMAIL, trigger: 'blur'}],
        roleIdList: [{required: true, validator: isRoleEmpty, trigger: 'change'}]
      },
      userMsg: {
        accountType: '',
        username: '',
        email: '',
        mobile: '',
        schoolId: '',
        unitName: '',
        status: '1',
        idCardType: '1',
        roleIdList: '',
        roleName: ''
      },
      allCardTypeList: [],
      defaultUser: {},
      allRoleList: [],
      parentRoleList: [],
      proList: [],
      bankList: [],
      allUnitList: [],
      parentUnitList: [],
      formLoading: true,
      formDefaultRules: {}
    }
  },
  created () {
    this.formDefaultRules = FormItemRules;
    this.fetchAllUnit().then(() => {
      this.fetchAllCardType();
      this.fetchUserMsg();
      this.fetchCanArrangeRoleList();
      this.fetchProList()
      this.fetchBankList()
    });
  },
  methods: {
    fetchAllUnit () {
      const _self = this;
      return new Promise(resolve => {
        _self.fetch('/school/school/querySchoolList', {keyWord: ''}).then(res => {
          _self.allUnitList = res.data.map(item => {
            return {
              value: item.id,
              label: item.code + '-' + item.name
            };
          });
          resolve();
        });
      });
    },
    fetchAllCardType () {
      this.fetch('/conf/confIdCardType/all').then(res => {
        this.allCardTypeList = res.data.map(item => {
          return {
            value: item.code,
            label: item.name
          };
        });
      });
    },
    fetchProList () {
      let url = '/conf/confProvince/list'
      this.post(url).then(res => {
        this.proList = res.data
      })
    },
    fetchBankList () {
      let url = '/conf/confBank/list'
      this.post(url).then(res => {
        this.bankList = res.data
      })
    },
    fetchCanArrangeRoleList () {
      this.fetch('/sys/role/queryCanArrangeRoleList').then(res => {
        this.allRoleList = res.data.map(item => {
          return {
            value: item.roleId,
            label: item.roleName
          };
        });
      });
    },
    fetchUserMsg () {
      const _self = this;
      _self.fetch('/sys/user/info').then(res => {
        _self.userMsg = Object.assign(_self.userMsg, res.data);
        if (_self.userMsg.accountType) _self.userMsg.accountType = _self.userMsg.accountType.split(',');
        if (_self.userMsg.roleIdList) _self.userMsg.roleIdList = _self.userMsg.roleIdList.split(',');
        _self.userMsg.status = _self.userMsg.status + '';
        _self.defaultUser = JSON.parse(JSON.stringify(res.data));

        if (_self.defaultUser.accountType) {
          if (_self.defaultUser.accountType.includes('3') || _self.defaultUser.accountType.includes('4')) {
            _self.$Message.warning({
              content: '默认为一级送审，如需调整，请前往“送审单位管理”',
              duration: 5
            });
          } else if (_self.defaultUser.accountType.includes('6') || _self.defaultUser.accountType.includes('8')) {
            _self.$Message.warning({
              content: '默认为一级指派，如需调整，请前往“指派单位管理”',
              duration: 5
            });
          }
        }

        _self.formLoading = false;
      });
    },
    // 确定回调事件
    saveOrUpdate () {
      const _self = this;
      _self.post('/sys/user/updateByLoginUser', this.userMsg).then(res => {
        if (res.code === 200) {
          this.$Message.success('保存成功')
        }
      }).catch(error => {
        this.$Message.error(error.msg)
      });
    }
  }
}
</script>

<style lang="less">
  .expert-info {
    .expType{
      width:100%!important
    }
    .form-label {
      color: #515a6e;
      display: block;
      font-size: 16px;
      font-weight: bold;
      margin-bottom: 10px;
    }
    .kh-date-picker{
      width: 100%;
    }
    .kh-form-item{
      width: 48%;
    }
    .form-item-online{
      width: 98% !important;
    }
    .kh-form-item-error-tip {
      right: 25px;
    }
  }
</style>
<style lang="less" scoped>
</style>



// WEBPACK FOOTER //
// src/layout/customPage/userInfoManage/userInfo.vue